import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Typography } from '../components/ui';

const TABS = [
  { to: '/settings/data-exchange-manager', label: 'Data Exchange' },
  { to: '/settings/custom-fields', label: 'Custom Fields' },
  { to: '/settings/org', label: 'Organization' },
  { to: '/settings/tax-rates', label: 'Tax Rates' },
  { to: '/settings/brands', label: 'Brands' },
  { to: '/settings/hsn-codes', label: 'HSN Codes' },
  { to: '/settings/bill-extraction-templates', label: 'Bill Extraction Templates' },
];

const tabStyle = (isActive: boolean): React.CSSProperties => ({
  padding: '0.5rem 1rem',
  borderBottom: isActive ? '2px solid var(--accent)' : '2px solid transparent',
  color: isActive ? 'var(--accent)' : 'var(--text-secondary)',
  fontWeight: isActive ? 600 : 500,
  textDecoration: 'none',
  whiteSpace: 'nowrap',
});

const Settings: React.FC = () => {
  return (
    <div className="min-h-screen p-6" style={{ color: 'var(--text-primary)' }}>
      <Typography variant="h1" className="mb-4">
        Settings
      </Typography>

      <div
        className="flex gap-1 mb-6 overflow-x-auto"
        style={{ borderBottom: '1px solid var(--border-primary)' }}
      >
        {TABS.map(tab => (
          <NavLink key={tab.to} to={tab.to} style={({ isActive }) => tabStyle(isActive)}>
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
};

export default Settings;
